/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAddIntegrationField } from './ControlAddIntegrationField';
import {
    ControlAddIntegrationFieldFromJSON,
    ControlAddIntegrationFieldFromJSONTyped,
    ControlAddIntegrationFieldToJSON,
} from './ControlAddIntegrationField';

/**
 * 
 * @export
 * @interface ControlAddOtherIntegrationDto
 */
export interface ControlAddOtherIntegrationDto {
    /**
     * 
     * @type {Array<ControlAddIntegrationField>}
     * @memberof ControlAddOtherIntegrationDto
     */
    fields: Array<ControlAddIntegrationField>;
}

/**
 * Check if a given object implements the ControlAddOtherIntegrationDto interface.
 */
export function instanceOfControlAddOtherIntegrationDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function ControlAddOtherIntegrationDtoFromJSON(json: any): ControlAddOtherIntegrationDto {
    return ControlAddOtherIntegrationDtoFromJSONTyped(json, false);
}

export function ControlAddOtherIntegrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAddOtherIntegrationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fields': ((json['fields'] as Array<any>).map(ControlAddIntegrationFieldFromJSON)),
    };
}

export function ControlAddOtherIntegrationDtoToJSON(value?: ControlAddOtherIntegrationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fields': ((value.fields as Array<any>).map(ControlAddIntegrationFieldToJSON)),
    };
}

